module.exports = __webpack_public_path__ + "static/media/logo.dd89e707.ico";